import EventCollectorContext from './EventCollectorContext';
import useEventCollectorValue from './useEventCollectorValue';

export default function EventCollectorContextProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const value = useEventCollectorValue();
  return (
    <EventCollectorContext.Provider value={value}>
      {children}
    </EventCollectorContext.Provider>
  );
}
